<div class="author-container">
  <div class="author-avatar">
    <img [src]="avatarUrl"  [alt]="author.name"/>
  </div>
  <div class="author-data">
    <div class="author-type">{{authorType}}</div>
    <div class="name">{{author.name}}</div>
  </div>
</div>
